import NativeStat from './NativeStat';
import NativeList from './NativeList';
import DonutChart from './DonutChart';
import LineChart from './LineChart';
import ValuationChart from './ValuationChart';
import AssetCard from './AssetCard';
import PeerComparison from './PeerComparison';
import CardList from './CardList';
import Gallery from './Gallery';

const COMPONENT_REGISTRY = {
    stat: NativeStat,
    stat_group: NativeStat,
    donut_chart: DonutChart,
    line_chart: LineChart,
    list: NativeList,
    valuation_chart: ValuationChart,
    asset_card: AssetCard,
    peer_comparison: PeerComparison,
    card_list: CardList,
    gallery: Gallery,
};

export default COMPONENT_REGISTRY;
